import { Button, Flex, Spinner } from "@radix-ui/themes";
import { siteRoutes } from "@/routes/siteRoutesList";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

export const CreateChallengeFooter: FC<{
  step: number;
  stepsAmount: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  handleNextStep: () => Promise<false | void>;
  isEdit: boolean;
  setIsEdit: any;
}> = ({
  step,
  setStep,
  loading,
  stepsAmount,
  handleNextStep,
  isEdit,
  setIsEdit,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {step !== 3 && (
        <Flex gap="3" my="5" justify="between">
          {step !== 0 && (
            <Button
              variant="soft"
              disabled={loading}
              onClick={() => setStep((s) => s - 1)}
            >
              Back
            </Button>
          )}
          {step === 0 && (
            <Button
              variant="soft"
              onClick={() => {
                if (isEdit) {
                  setIsEdit(false);
                } else {
                  navigate(siteRoutes["challenges"]);
                }
              }}
            >
              Cancel
            </Button>
          )}
          {isEdit ||
            (step !== 0 && (
              <Button
                disabled={loading}
                variant="solid"
                onClick={() => handleNextStep()}
              >
                {loading ? (
                  <Spinner />
                ) : (
                  <>{step === stepsAmount - 1 ? "Preview" : "Next step"}</>
                )}
              </Button>
            ))}
        </Flex>
      )}
    </>
  );
};
